import React, { useRef, useState, useCallback, useEffect } from 'react'

import {
    Box,
    Grid,
    Button,
    styled,
    Card,
    List,
    ListSubheader,
    ListItem,
    ListItemButton,
    IconButton,
    Skeleton,
    Chip
} from '@mui/material';

import { grey } from "@mui/material/colors";
import { useNavigate, Link, useParams } from 'react-router-dom';
import CommonBreadcumbs from '../../common/CommonBreadcumbs';
import CommonRestricted from '../../common/CommonRestricted';
import { CommonIcons, icons } from "../../common/CommonIcons";
import CommonSectionHeader from "../../common/CommonSectionHeader";

import { useAppContextFeatures } from "../../../context/AppContext";

// import { useDataGridParams } from '../../../hooks/useDataGridParams';
import { useSystemPrompt } from '../../../hooks/useSystemPrompt';
import { useRegions, regionTypes, targetTypes } from '../../../hooks/api/useRegions';
import { useSystemRoutes, routeTypes } from '../../../hooks/useSystemRoutes';
import { useSystemHead, headTitles } from '../../../hooks/useSystemHead';
import { useTranslations } from "../../../hooks/useTranslations";

import { usePermissions, scopeIds, scopeTypes, functionTypes } from '../../../hooks/usePermissions';

import NewArea from "../areas/NewArea"
import UpdateArea from '../areas/UpdateArea';

const StyledCard = styled(Card)(({ theme }) => ({
    padding: theme.spacing(2)
}));

const StyledCard2 = styled(Card)(({ theme }) => ({
    padding: theme.spacing(0)
}));

const StyledListHeader = styled(ListSubheader)(({ theme }) => ({
    // padding: theme.spacing(0),
    backgroundColor: grey[100],
    textTransform: 'capitalize',
}));

export default function UpdateCountry({
    routeType
}) {
    const { t } = useTranslations({ ns: ["common", "@region"] })

    const { id } = useParams();

    const navigate = useNavigate();
    const { promptMessage } = useSystemPrompt();
    const { list, remove, filterOperatorTypes } = useRegions({ regionType: regionTypes.state, targetType: targetTypes.state });

    const [selectedIds, setSelectedIds] = useState([])
    const { getRoute } = useSystemRoutes(routeType);
    const { getHtmlHead } = useSystemHead(routeType)

    const { setSystemLoading, openCustomDrawer, closeCustomDrawer } = useAppContextFeatures();
    const [selectedId, setSelectedId] = useState("")
    const [loadingChildren, setLoadingChildren] = useState(false)
    const [dataStates, setDataStates] = useState([])

    const { isPermissionAllow } = usePermissions(routeType, scopeIds.region.id, scopeTypes.region.country.id)

    const [child, setChild] = useState({
        states: [],
        areas: []
    })

    const fetchDataStates = async (countryId) => {

        setDataStates([])

        try {

            const props = {
                limit: -1,
                skip: 0,
                sortInfo: {
                    id: "id",
                    dir: 0,
                },
                filterValue: [
                    {
                        name: "country_id",
                        operator: filterOperatorTypes.eq,
                        value: id
                    }
                ]
            };

            props.regionType = regionTypes.state
            props.countryId = countryId
            props.dataTypes = ["area_count"];

            const { data } = await list(props)
            const { states } = data

            // setChild(
            //     {...child, states  }
            // )

            setChild((prev) => {
                return { ...prev, states }
            })

        } catch (error) {
            promptMessage(false, `${error?.message}`)
        }

    }

    const fetchChildren = async (id) => {

        if (!id) return false

        setLoadingChildren(true)

        try {

            const props = {
                limit: -1,
                skip: 0,
                sortInfo: {
                    id: "id",
                    dir: 0,
                },
                filterValue: [
                    {
                        name: "state_id",
                        operator: filterOperatorTypes.eq,
                        value: id
                    }
                ]
            };

            props.regionType = regionTypes.area
            props.stateId = id

            const { data } = await list(props)
            const { areas } = data;

            // setChild(
            //     { ...child, areas }
            // )

            setChild((prev) => {
                return { ...prev, areas }
            })

            setSelectedId(id)

        } catch (error) {
            // promptMessage(false, `${error?.message}`)
        }

        setLoadingChildren(false)

        return true;

    }

    useEffect(() => {

        fetchDataStates(id);

    }, [])

    const RenderRegion = () => {

        return (
            <StyledCard>
                <Grid container spacing={0.5}>

                    <Grid item xs={12} sm={12} md={3} textAlign={"left"}>

                        <CommonSectionHeader
                            title={t('statesAndAreas')}
                            subTitle={t('definePreciseLocation')}
                        />

                    </Grid>

                    <Grid item xs={12} sm={12} md={9}>
                        {
                            RenderSection()
                        }
                    </Grid>
                </Grid>
            </StyledCard>
        )
    }

    const RenderSection = () => {

        return (
            <Grid container spacing={0}>

                <Grid item md={5.5} sm={12} xs={12}>
                    {
                        RenderStates()
                    }
                </Grid>

                <Grid item md={1} sm={12} xs={12} display={"flex"} justifyContent={"center"} alignItems={"center"}>
                    <CommonIcons name={icons.chevronRight} />
                </Grid>

                <Grid item md={5.5} sm={12} xs={12}>
                    {
                        RenderAreas()
                    }
                </Grid>

            </Grid>
        )
    }

    const handleStateClick = ({ id }) => {
        console.log("ID", id)
        fetchChildren(id)
    }

    const RenderStateNotSelected = () => {
        return (
            <StyledCard2>
                <Box
                    sx={{
                        width: '100%',
                        position: 'relative',
                        overflow: 'auto',
                        minHeight: 300,
                    }}
                    display={"flex"}
                    flexDirection={"column"}
                    justifyContent={"center"}
                    alignItems={"center"}
                >
                    <Box>
                        {t('youHaveNotmakeAnySelection')}
                    </Box>
                </Box>
            </StyledCard2>
        )
    }

    const RenderListDataItemSkeleton = () => {
        return (
            <ListItem
                disablePadding
                divider
            >
                <Skeleton
                    animation="wave"
                    // variant="circular" 
                    sx={{
                        // minWidth: 100,
                        width: '100%',
                        // mr: 1,
                        height: 40,
                        mx: 1
                    }}
                />
            </ListItem>
        )
    }

    const handleItemNew = ({ regionType = '', parentId }) => {

        if (!regionType) return false

        openCustomDrawer({
            show: true,
            anchor: "right",
            title: `${regionType === regionTypes.state ? "New State" : "New Area"}`,
            PaperProps: {
                sx: { width: 2 / 3 }
            },
            handleOnClose: () => { },
            ComponentActions:
                <></>,
            ComponentBody:

                <NewArea
                    routeType={routeType}
                    parentId={parentId}
                    handleOnSuccess={() => {
                        closeCustomDrawer()

                        fetchDataStates(id)

                        if (selectedId)
                            fetchChildren(selectedId)
                    }}
                />

        })

        return true;

    }

    const handleItemEdit = ({ regionType = '', itemId, parentId }) => {

        if (!regionType) return false;

        openCustomDrawer({
            show: true,
            anchor: "right",
            title: t("updateArea"),
            PaperProps: {
                sx: { width: 2 / 3 }
            },
            handleOnClose: () => { },
            ComponentActions:
                <></>,
            ComponentBody:

                <UpdateArea
                    routeType={routeType}
                    id={itemId}
                    parentId={parentId}
                    handleOnSuccess={() => {
                        closeCustomDrawer()
                        // fetchDataStates(id)
                        // fetchChildren(id)
                        if (selectedId)
                            fetchChildren(selectedId)
                    }}

                />

        })

        return true;

    }

    const handleItemDelete = async ({ itemId, targetType }) => {

        setSystemLoading(true)

        try {

            let result = await remove({ ids: [itemId], targetType })
            promptMessage(true, result?.message)

            fetchDataStates(id)

            if (selectedId)
                fetchChildren(selectedId)

        } catch (error) {
            promptMessage(false, `Action Failed (${error?.message})`)
        }

        setSystemLoading(false)

    }

    const RenderEmpty = ({ regionType = '', parentId }) => {

        if (!regionType) return <></>

        return (
            <StyledCard2>
                <Box
                    sx={{
                        width: '100%',
                        position: 'relative',
                        overflow: 'auto',
                        minHeight: 300,
                    }}
                    display={"flex"}
                    flexDirection={"column"}
                    justifyContent={"center"}
                    alignItems={"center"}
                >
                    <Box>
                        {t('youHaveNotCreatedAnyItemYet')}
                    </Box>
                    <Button
                        variant="outlined"
                        sx={{
                            mt: 1
                        }}
                        onClick={() => handleItemNew({ regionType, parentId })}
                    >
                        {t('createNew')}
                    </Button>
                </Box>
            </StyledCard2>
        )
    }

    const RenderStates = () => {

        if (!child.states.length) return <RenderEmpty regionType={regionTypes.state} parentId={id} />

        return (
            <StyledCard2>
                <List
                    sx={{
                        width: '100%',
                        position: 'relative',
                        overflow: 'auto',
                        minHeight: 300,
                        '& ul': { padding: 0 },
                    }}
                    // subheader={<li />}
                    disablePadding
                >
                    <StyledListHeader>{t("states")}</StyledListHeader>
                    {
                        child.states.map((i, index) => (
                            <ListItem
                                key={`${index}`}
                                disablePadding
                                divider
                            >
                                <ListItemButton
                                    disableGutters
                                    sx={{
                                        px: 2
                                    }}
                                    onClick={() => handleStateClick({ id: i.id })}
                                    selected={
                                        selectedId === i.id
                                    }
                                >
                                    <Grid container spacing={1}>
                                        <Grid item md={10} sm={10} xs={10} display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                            {`
                                                ${i?.state_name}`
                                            }

                                        </Grid>
                                        <Grid item md={2} sm={2} xs={2} display={"flex"} justifyContent={"flex-end"} alignItems={"center"}>
                                            {
                                                parseInt(i.area_count, 10) > 0 ?
                                                    (
                                                        <Chip
                                                            label={`${i.area_count}`}
                                                            variant={"contained"}
                                                            color={"default"}
                                                        />
                                                    )
                                                    :
                                                    (
                                                        <></>
                                                    )
                                            }

                                        </Grid>
                                        {/* <Grid item md={1} sm={1} xs={1} display={"flex"} justifyContent={"center"} alignItems={"center"}>
                                            <IconButton
                                                color={"primary"}
                                                size="small"
                                                onClick={() => handleItemEdit({ regionType: regionTypes.state, itemId: i.id, parentId: i.location_id}) }
                                            >
                                                <CommonIcons name={icons.edit} />
                                            </IconButton>
                                            <IconButton
                                                color={"error"}
                                                size="small"
                                                onClick={() => handleItemDelete({ itemId: i.id, targetType: targetTypes.rack }) }
                                                sx={{
                                                    mr: 2
                                                }}
                                            >
                                                <CommonIcons name={icons.remove} />
                                            </IconButton>
                                        </Grid> */}
                                    </Grid>
                                </ListItemButton>
                            </ListItem>
                        ))
                    }
                </List>

                {/* <Box
                    sx={{ m: 1 }}
                >
                    <Button
                        variant={"outlined"}
                        size="medium"
                        fullWidth
                        onClick={() => handleItemNew({ regionType: regionTypes.state, parentId: id })}
                    >   
                        <CommonIcons name={icons.add} />
                        <Box sx={{ ml: 1 }}>
                            New
                        </Box>
                    </Button>
                </Box> */}
            </StyledCard2>
        )
    }

    const RenderAreas = () => {

        // check is loading
        if (loadingChildren) {
            return (
                <StyledCard2>
                    <List
                        sx={{
                            width: '100%',
                            position: 'relative',
                            overflow: 'auto',
                            // height: '100%',
                            minHeight: 300,
                            '& ul': { padding: 0 },
                        }}
                        disablePadding
                    >
                        <StyledListHeader>{`Areas`}</StyledListHeader>
                        {
                            [0, 1, 2, 3].map((i, index) => {
                                return (
                                    <RenderListDataItemSkeleton key={index} />
                                )
                            })
                        }
                    </List>
                </StyledCard2>
            )
        }

        if (!selectedId) return <RenderStateNotSelected />
        if (!child.areas.length) return <RenderEmpty regionType={regionTypes.area} parentId={selectedId} />

        return (
            <StyledCard2>
                <List
                    sx={{
                        width: '100%',
                        position: 'relative',
                        overflow: 'auto',
                        minHeight: 300,
                        '& ul': { padding: 0 },
                    }}
                    disablePadding
                >
                    <StyledListHeader>{t(`areas`)}</StyledListHeader>
                    {
                        child.areas.map((i, index) => (
                            <ListItem
                                key={`${index}`}
                                disablePadding
                                divider
                            >
                                <ListItemButton
                                    disableGutters
                                    sx={{
                                        px: 2
                                    }}
                                >
                                    <Grid container spacing={1}>
                                        <Grid item md={11} sm={11} xs={11} display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                            {
                                                `${i.area_name}`
                                            }

                                            {
                                                i?.status !== "1" &&
                                                <Box sx={{ ml: 1, mt: 1 }}>
                                                    <CommonIcons name={icons.disabled} />
                                                </Box>
                                            }

                                        </Grid>
                                        <Grid item md={1} sm={1} xs={1} display={"flex"} justifyContent={"center"} alignItems={"center"}>
                                            {
                                                isPermissionAllow({ scopeType: scopeTypes.region.area.id, functionType: functionTypes.pageUpdate.id }) &&

                                                <IconButton
                                                    color={"primary"}
                                                    size="small"
                                                    onClick={() => handleItemEdit({ regionType: regionTypes.area, itemId: i.id, parentId: i.state_id })}
                                                >
                                                    <CommonIcons name={icons.edit} />
                                                </IconButton>
                                            }
                                            {
                                                isPermissionAllow({ scopeType: scopeTypes.region.area.id, functionType: functionTypes.remove.id }) &&

                                                <IconButton
                                                    color={"error"}
                                                    size="small"
                                                    onClick={() => handleItemDelete({ itemId: i.id, targetType: targetTypes.area })}
                                                    sx={{
                                                        mr: 2
                                                    }}
                                                >
                                                    <CommonIcons name={icons.remove} />
                                                </IconButton>
                                            }
                                        </Grid>
                                    </Grid>
                                </ListItemButton>
                            </ListItem>
                        ))
                    }
                </List>
                <Box
                    sx={{ m: 1 }}
                >
                    {
                        isPermissionAllow({ scopeType: scopeTypes.region.area.id, functionType: functionTypes.pageNew.id }) &&

                        <Button
                            variant={"outlined"}
                            size="medium"
                            fullWidth

                            onClick={() => handleItemNew({ regionType: regionTypes.area, parentId: selectedId })}
                        >
                            <CommonIcons name={icons.add} />
                            <Box sx={{ ml: 1 }}>
                                New
                            </Box>
                        </Button>

                    }
                </Box>
            </StyledCard2>
        )
    }

    return (
        <Box>
            {
                getHtmlHead({ routeType, title: headTitles.updateRegion })
            }

            <CommonBreadcumbs
                routeType={routeType}
                pageTitle={t("updateCountry")}
                breadcrumbs={[
                    {
                        displayText: t("countries"),
                        props: {
                            href: getRoute('settings/countries')
                        }
                    },
                    {
                        displayText: t("updateCountry"),
                        props: {
                            color: 'secondary.main'
                        }
                    }
                ]}
            />

            {
                isPermissionAllow({ functionType: functionTypes.pageUpdate.id }) ?
                    RenderRegion()
                    :
                    <CommonRestricted />
            }

        </Box>
    )
}
